import { Injectable } from "@angular/core";
import { ToastrService } from "@kpmg-tax/ui";
import { BehaviorSubject, Observable } from "rxjs";
import { API_URL } from "src/app/shared/constants/apiurl-constants";
import { LegalEntities } from "src/app/shared/models/legal-entity/legal-entity.model";
import { SessionService } from "src/app/shared/session-service/session.service";

@Injectable({
  providedIn: 'root',
})
export class LegalEntitiesService {
  entitiesTableRefresh = new BehaviorSubject({});
  refreshEntities = this.entitiesTableRefresh.asObservable();
  entitiesInserted = new BehaviorSubject({});
  entitiesInsrtedAlert = this.entitiesInserted.asObservable();

  private _legalEntities: Array<LegalEntities>;


  constructor(public sessionService: SessionService, public toastrService: ToastrService,) { }

  refreshTable() {
    this.entitiesTableRefresh.next(true);
  }

  get legalEntities(): Array<LegalEntities> {
    return this._legalEntities;
  }
  set legalEntities(value: Array<LegalEntities>) {
    this._legalEntities = value;
  }

  getLegalEntities(engagementId: number): Observable<any> {
    let entities = this.sessionService.apiUrlGet(
      API_URL.LEGAL_ENTITY.GET_ENTITIES + '?engagementId=' + engagementId,
    );
    return entities;
  }

  deletelegalEntityRec(data) {
    return this.sessionService.apiUrlPost(
      API_URL.LEGAL_ENTITY.DELETE_ENTITY,
      data,
    );
  }

}